<i18n>
{
    "uk": {
        "nextPage": "Наступна сторінка",
        "prevPage": "Попередня сторінка"
    },

    "en": {
        "nextPage": "Next page",
        "prevPage": "Previous page"
    }
}
</i18n>

<template>
    <div
        class="pagination-companent"
        v-if="stepsLength > 1"
        :class="{
            busy: busy
        }"
    >
         <button
            v-if="this.page != this.stepsLength && this.load"
            @click="$emit('load', page)"
            class="load-page mb-3"
        >
            <div
                v-if="!loading"
                class="d-flex align-items-center"
            >
                <span class="color-gray-3 icon-ic-union icon" /> {{$t('general.loadMore')}}
            </div>

            <div
                v-else
                class="d-flex align-items-center"
            >
                <span class="icon">💫</span> {{$t('general.loading')}}
            </div>
        </button>


        <div class="pagination d-flex">
            <nuxt-link
                :class="{show: page != 1}"
                :to="{path, query: stepQuery(page-1)}"
                custom
                v-slot="{ href }"
            >
                <a
                    class="icon-ic-arrow-simple btn-bg prev mr-auto"
                    @click.prevent="$emit('change', page - 1)"
                    :href="href"
                    :title="$t('prevPage')"
                />
            </nuxt-link>

            <nuxt-link
                v-if="!visibleSteps.includes(1)"
                :to="{path, query: stepQuery(1)}"
                custom
                v-slot="{ href }"
            >
                <a
                    class="btn-paginations"
                    @click.prevent="$emit('change', 1)"
                    :href="href"
                >
                    1
                </a>
            </nuxt-link>

            <div
                v-if="!visibleSteps.includes(1) && !visibleSteps.includes(2)"
                class="dots"
            >...</div>


            <nuxt-link
                v-for="(visibleStep) in visibleSteps"
                :key="`step-${visibleStep}`"
                :class="{active: visibleStep == page}"
                :to="{path, query: stepQuery(visibleStep)}"
                custom
                v-slot="{ href }"

            >
                <a
                    class="btn-paginations"
                    @click.prevent="$emit('change', visibleStep)"
                    :href="href"
                >
                    {{visibleStep}}
                </a>
            </nuxt-link>

            <div
                v-if="!visibleSteps.includes(stepsLength) && !visibleSteps.includes(stepsLength - 1)"
                class="dots"
            >
                ...
            </div>

            <nuxt-link
                v-if="!visibleSteps.includes(stepsLength)"
                :to="{path, query: stepQuery(stepsLength)}"
                custom
                v-slot="{ href }"
            >
                <a
                    class="btn-paginations"
                    @click.prevent="$emit('change', stepsLength)"
                    :href="href"
                >
                    {{stepsLength}}
                </a>
            </nuxt-link>

            <nuxt-link
                :class="{show: page != stepsLength}"
                :to="{path, query: stepQuery(page + 1)}"
                custom
                v-slot="{ href }"
            >
                <a
                    class="icon-ic-arrow-simple btn-bg next ml-auto"
                    @click.prevent="$emit('change', page + 1)"
                    :href="href"
                    :title="$t('nextPage')"
                />
            </nuxt-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        length: {
            type: Number,
            required: true
        },
        limit: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        visibleLength: {
            type: Number,
            default: 5
        },

        load: {
            type: Boolean,
            default: true
        },

        loading: {
            type: Boolean,
            default: false
        },

        busy: {
            type: Boolean,
            default: false
        },
        param: {
            type: String,
            default: 'page'
        }
    },

    data () {
        return {

        }
    },

    computed: {
        path () {
            return this.$route.path;
        },

        query () {
            let clone = Object.assign({}, this.$route.query);
            delete clone[this.param];

            return clone;
        },

        stepsLength () {
            let length = Math.floor(this.length/this.limit);
            if (this.length % this.limit) length++;

            return length;
        },

        visibleSteps () {
            if (this.stepsLength <= this.visibleLength) {
                return this.fillSteps(1, this.stepsLength);
            }

            let delta = Math.floor(this.visibleLength / 2);

            let bottomIncrement = 0;
            let topIncrement = 0;

            if (this.page - delta <= 0) {
                bottomIncrement = delta - this.page + 1;
                topIncrement = delta - this.page + 1;
            }

            if (this.page + delta > this.stepsLength) {
                bottomIncrement = this.stepsLength - (this.page + delta);
                topIncrement =  this.stepsLength - (this.page + delta);
            }

            let bottom = this.page - delta + bottomIncrement;
            let top = this.page + delta + topIncrement;

            return this.fillSteps(bottom, top);
        }
    },

    methods: {
        fillSteps (bottom, top) {
            let arr = [];

            for (let i = bottom; i <= top; i++) {
                arr.push(i);
            }

            return arr;
        },

        stepQuery (page){
            let clone  = Object.assign({}, this.query);
            clone[this.param] = page;

            return clone;
        }
    }
}
</script>

<style lang="scss" scoped>
    .pagination-companent {
        position: relative;

        &.busy {
            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 3;
                cursor: wait;
            }
        }
    }


    .load-page {
        cursor: pointer;
        padding: 18px;
        text-transform: uppercase;
        margin: 0 auto;

        width: 100%;

        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        border-radius: 8px;

        display: flex;
        align-items: center;
        justify-content: center;

        .icon{
            font-size: 20px;
            margin-right: 8px;
        }
    }

    .dots {
        user-select: none;
        background: transparent;
        color: var(--color-cases-gray-0);

        width: 32px;
        height: 32px;
        padding: 4px;

        display: flex;
        justify-content: center;
        margin: 0 4px;
    }

    .btn-bg {
        width: 32px;
        height: 32px;
        padding: 4px;
        font-size: 16px;

        opacity: 0;
        pointer-events: none;

        &.show {
            opacity: 1;
            pointer-events: all;
        }
    }

    .next:before {
        transform: rotate(-90deg);
    }

    .prev:before {
        transform: rotate(90deg);
    }

    .btn-paginations {
        min-width: 32px;
        height: 32px;
        padding: 4px;

        display: flex;
        // align-items: center;
        justify-content: center;

        border-radius: 4px;
        margin: 0 4px;

        &.active {
            color: var(--color-cases-blue-100);
            background-color: var(--color-cases-sky-80);
            pointer-events: none;
        }
    }

    .load-page,
    .btn-paginations {
        background: transparent;
        color: var(--color-cases-gray-0);

        border: none;
        user-select: none;
        outline: none;

        transition: color .15s ease,
                    background-color .15s ease;

        &:hover {
            background-color: var(--color-cases-sky-60);
        }

        &:active {
            background-color: var(--color-cases-sky-100);
        }

        &:focus-visible {
            outline: 2px solid var(--color-cases-sofus-outline);
        }
    }
</style>
